import { personalReviews } from "./reviews.js"; 

(function() {
    const personalOffice = document.querySelector('.personal-office');

    if (!personalOffice) return;

    const officeUrl = window.location.pathname;
    let userID = null;

    const getUser = async () => {
        try {
            const user = await fetch('/rest/api.user.get');

            return user.json();

        } catch(err) {console.log(err)}
    }

    const startLogic = () => {
        if (officeUrl === '/personal/reviews/') personalReviews(personalOffice, userID);
    }

    const init = () => {
        getUser().then(user => {
            userID = user.result.ID;

            startLogic();
        });
    }

    init();

} ())